import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NextAvailableScheduleDay from './NextAvailableScheduleDay';
import { getNextAvailablePublishedDraws } from '../../../../../actions/event-profile-actions';

import styles from './scheduleTab.scss';

const NextAvailableSchedule = () => {
    const dispatch = useDispatch();
    const { event, nextAvailableSchedule } = useSelector(({ eventProfile }) => {
        const { event, nextAvailableSchedule = {} } = eventProfile;
        return { event, nextAvailableSchedule };
    });

    const loadNextAvailableSchedule = (eventId) => {
        dispatch(getNextAvailablePublishedDraws(eventId));
    };

    useEffect(() => {
        loadNextAvailableSchedule(event?.data?.id);
    }, [event?.data?.id]);

    return (
        <div className={styles.nextAvailableSchedule}>
            {nextAvailableSchedule?.loading && (
                <div className={styles.spinner}>
                    <div className={styles.iconWrapper}>
                        <i className="icon-utr-logo" />
                        <div className={styles.iconSpinner} />
                        <div className={`${styles.iconSpinner} ${styles.reverse}`} />
                    </div>
                    <div className={styles.title}>Loading</div>
                </div>
            )}
            {nextAvailableSchedule.schedule?.length > 0 && nextAvailableSchedule.schedule.map((scheduleDay) => {
                return (
                    <NextAvailableScheduleDay
                        key={`schedule-day-${scheduleDay.date}`}
                        scheduleDay={scheduleDay}
                        eventSchedule={event?.data?.eventSchedule}
                        useEventTimeZone={true}
                    />
                );
            })}
            {nextAvailableSchedule.schedule?.length === 0 && (
                <div className={styles.noData}>
                    Schedule has not been published
                </div>
            )}
        </div>
    );
};

NextAvailableSchedule.propTypes = {};

NextAvailableSchedule.defaultProps = {};

export default NextAvailableSchedule;
